<form [formGroup]="form">
  <div class="company-detail">
    <h1>Company Details</h1>
    <app-input
      label="Company Name"
      type="text"
      [control]="form.get('company_name')"
      [errorMessage]="getErrorMessage('company_name')"
      maxlength="50"
    ></app-input>
    <app-input
      label="First Name"
      type="text"
      [control]="form.get('first_name')"
      [errorMessage]="getErrorMessage('first_name')"
      class="w-50"
    ></app-input>
    <app-input
      label="Last Name"
      type="text"
      [control]="form.get('last_name')"
      [errorMessage]="getErrorMessage('last_name')"
      class="w-50"
    ></app-input>
    <app-input
      label="Phone Number"
      type="text"
      [control]="form.get('telephone_number')"
      [errorMessage]="getErrorMessage('telephone_number')"
      class="w-50"
      [isTelephone]="true"
      (blurEvent)="checkUnique('telephone_number')"
    ></app-input>
    <app-input
      label="Email"
      type="email"
      [control]="form.get('email')"
      [errorMessage]="getErrorMessage('email')"
      class="w-50"
      (blurEvent)="checkUnique('email')"
    ></app-input>
    <app-input
      label="Password"
      type="password"
      [control]="form.get('password')"
      [errorMessage]="getErrorMessage('password')"
    ></app-input>
    <app-input
      label="Confirm Password"
      type="password"
      [control]="form.get('confirm_password')"
      [errorMessage]="getErrorMessage('confirm_password')"
    ></app-input>
    <p class="w-100">Optional</p>
    <app-input
      label="Industry"
      type="text"
      [control]="form.get('industry')"
      [errorMessage]="getErrorMessage('industry')"
      class="w-50"
      maxlength="50"
    ></app-input>
    <app-input
      label="Approx no. of drivers"
      type="text"
      [control]="form.get('number_of_drivers')"
      [errorMessage]="getErrorMessage('number_of_drivers')"
      class="w-50"
      maxlength="5"
    ></app-input>
    <div class="terms-checkbox">
      <mat-checkbox
        class="check"
        color="primary"
        formControlName="isTermsAndCondition"
      >
        I Agree to Delm8’s
        <a
          href="https://delm8.com/terms-and-conditions/"
          class="hyperlink"
          target="_blank"
          >terms and conditions</a
        >
        and
        <a href="https://delm8.com/privacy/" class="hyperlink" target="_blank"
          >privacy policy</a
        >*
      </mat-checkbox>
      <mat-error
        *ngIf="
          form.controls['isTermsAndCondition'].errors &&
          form.controls['isTermsAndCondition'].touched
        "
        class="error-message checkbox-error"
      >
        Please agree to the terms and conditions.
      </mat-error>
    </div>
  </div>
  <div class="captcha-container">
    <re-captcha
      id="captchaToken"
      name="captchaToken"
      #captchaRef="reCaptcha"
      [(ngModel)]="captchaToken"
      [ngModelOptions]="{ standalone: true }"
      (resolved)="onCaptchaResolved($event)"
    ></re-captcha>
    <div class="text-danger" *ngIf="!isVerifiedCaptcha">
      Captcha verification falied.
    </div>
  </div>
  <button
    mat-flat-button
    class="primary-btn"
    matStepperNext
    [disabled]="!form.valid || !(isVerifiedCaptcha && captchaToken)"
    [ngClass]="{
      disabled: !form.valid || !(isVerifiedCaptcha && captchaToken)
    }"
  >
    Next
  </button>
  <div class="d-flex justify-content-center link-block">
    Already have an account?
    <span routerLink="/login" class="link-primary">Login</span>
  </div>
</form>
